import { render, staticRenderFns } from "./RegDocumentsWrap.vue?vue&type=template&id=58d4e7fc&scoped=true"
import script from "./RegDocumentsWrap.vue?vue&type=script&lang=js"
export * from "./RegDocumentsWrap.vue?vue&type=script&lang=js"
import style0 from "./RegDocumentsWrap.vue?vue&type=style&index=0&id=58d4e7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d4e7fc",
  null
  
)

export default component.exports